import {
  DynamicAspect,
  ImageAspectRatio,
  ImageOrientation,
} from '../../components/Blocks/BlockImageList/ImageSettings';

type Position = { x: number, y: number };

export type Size = { width: number, height: number };

interface ImageSettings {
  scale?: number;
  position?: Position;
  size?: Size;
  frameSize?: Size;
  orientation: ImageOrientation;
  aspectRatio: ImageAspectRatio;
  dynamicAspect: DynamicAspect;
  fixedAspect: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace ImageSettings {
  export function make(scale: number, position: Position, size: Size, frameSize?: Size): ImageSettings {
    return {
      scale,
      position,
      size,
      frameSize,
      orientation: ImageOrientation.Landscape,
      aspectRatio: ImageAspectRatio.SixteenByNine,
      dynamicAspect: DynamicAspect.Auto,
      fixedAspect: true,
    };
  }

  export function getDefault(
    scale = 1,
    position = { x: 0, y: 0 },
    size = { width: 100, height: 100 },
    frameSize = { width: 100, height: 100 },
  ): ImageSettings {
    return {
      scale,
      position,
      size,
      frameSize,
      orientation: ImageOrientation.Landscape,
      aspectRatio: ImageAspectRatio.SixteenByNine,
      dynamicAspect: DynamicAspect.Auto,
      fixedAspect: true,
    };
  }
}

export default ImageSettings;
